import { Edge } from 'reactflow';

export function findConnectedComponents(
  nodeIds: string[],
  edges: Edge[]
): string[][] {
  const adjacencyList = new Map<string, string[]>();
  
  nodeIds.forEach(id => adjacencyList.set(id, []));
  
  edges.forEach(edge => {
    if (nodeIds.includes(edge.source) && nodeIds.includes(edge.target)) {
      adjacencyList.get(edge.source)?.push(edge.target);
      adjacencyList.get(edge.target)?.push(edge.source);
    }
  });
  
  const visited = new Set<string>();
  const components: string[][] = [];
  
  function dfs(nodeId: string, component: string[]) {
    visited.add(nodeId);
    component.push(nodeId);
    
    adjacencyList.get(nodeId)?.forEach(neighbor => {
      if (!visited.has(neighbor)) {
        dfs(neighbor, component);
      }
    });
  }
  
  nodeIds.forEach(nodeId => {
    if (!visited.has(nodeId)) {
      const component: string[] = [];
      dfs(nodeId, component);
      if (component.length >= 1) {
        components.push(component);
      }
    }
  });
  
  return components;
}

export function areNodesConnected(
  nodeId1: string,
  nodeId2: string,
  edges: Edge[]
): boolean {
  return edges.some(
    edge =>
      (edge.source === nodeId1 && edge.target === nodeId2) ||
      (edge.source === nodeId2 && edge.target === nodeId1)
  );
}

export function getConnectedNodes(nodeId: string, edges: Edge[]): string[] {
  const connected = new Set<string>();
  
  edges.forEach(edge => {
    if (edge.source === nodeId) {
      connected.add(edge.target);
    } else if (edge.target === nodeId) {
      connected.add(edge.source);
    }
  });
  
  return Array.from(connected);
}
